import React, { cloneElement, Component } from 'react'
import PropTypes from 'prop-types'
import { Field, FieldArray } from 'redux-form/immutable'
import ContentSection from 'app/components/ContentSection'
import PushSubscribeButton from 'app/domains/common/PushSubscribeButton'
import { emptyArray } from 'helpers/validators'
import WorkWeekFieldArray from './WorkWeekFieldArray'
import InputPhoneNumber from 'app/domains/common/InputPhoneNumber'
import RadioButtonNotificationType from './RadioButtonNotificationType'
import { types } from 'app/constants/notificationType'
import ErrorBlock from 'app/components/ErrorBlock'
import SelectTimeZonesField from 'app/domains/common/SelectTimeZonesField'
import SelectTimeField from 'app/domains/common/SelectTimeField'
import ConfirmationNotificationTypeForm from './ConfirmationNotificationTypeForm'
import Spinner from 'app/components/Spinner/Spinner'

import './styles.scss'

const bc = 'common-time-preferences-form'
const id = bc

const radioElements = [
  {
    text: 'Email',
    value: types.EMAIL,
  },
  {
    text: 'Text Message',
    value: types.SMS,
  },
  {
    text: 'Both',
    value: types.BOTH,
  },
]

class TimePreferencesForm extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    handleChange: PropTypes.func,
    morningHours: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
    eveningHours: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
    fieldWasChanged: PropTypes.func.isRequired,
    /** footer with submit button */
    children: PropTypes.node,
    className: PropTypes.string,
    submitting: PropTypes.bool,
    pristine: PropTypes.bool,
    isHasIrregularWorkWeek: PropTypes.bool,
    timezone: PropTypes.string,
    isSMSAvailable: PropTypes.bool,
    notificationTypeValue: PropTypes.string,
    isIdentityHasSmsNotificationType: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool.isRequired,
    setComponentsHeight: PropTypes.func,
  }

  state = {
    isShowConfirmationNotificationTypeSection: false,
  }

  changeIsShowConfirmationNotificationType = bool => {
    this.setState({ isShowConfirmationNotificationTypeSection: bool })
  }

  componentDidMount() {
    const { setComponentsHeight } = this.props
    if (setComponentsHeight) {
      setComponentsHeight(id)
    }
  }

  componentDidUpdate(prevProps) {
    const { setComponentsHeight, notificationTypeValue } = this.props
    if (setComponentsHeight && prevProps.notificationTypeValue !== notificationTypeValue) {
      setComponentsHeight(id)
    }
  }

  render() {
    const {
      t,
      handleSubmit,
      morningHours,
      eveningHours,
      fieldWasChanged,
      /** footer with submit button */
      children,
      className = '',
      submitting,
      pristine,
      invalid,
      isHasIrregularWorkWeek,
      isDesktopNotificationsAvailable,
      timezone,
      isSMSAvailable,
      notificationTypeValue,
      showModal,
      isIdentityHasSmsNotificationType,
      form,
      error,
      isLoginFlowFinished,
      isLoading
    } = this.props
    const { isShowConfirmationNotificationTypeSection } = this.state
    const isShowPhoneInput =
      isSMSAvailable && (notificationTypeValue === types.SMS || notificationTypeValue === types.BOTH)
    return (
      <form onSubmit={handleSubmit} className={className} id={id}>
        {isShowConfirmationNotificationTypeSection && <div className={`${bc}__cover`} />}
        {isHasIrregularWorkWeek ?
          isLoading && isLoginFlowFinished
        ? <div className={`${bc}__spinner`}><Spinner transparent /> </div>
        : (<ContentSection title={t('Your ProHabits’ Planner')}>
            <FieldArray
              name="workWeek"
              component={WorkWeekFieldArray}
              validate={[emptyArray(t('Please select at least one work day'))]}
            />
          </ContentSection>)
        : null
      }
        <ContentSection
          title={t('Time Preferences')}
          isLastSection={!isShowPhoneInput && !isDesktopNotificationsAvailable}
        >
          <SelectTimeField
            name="commitNotificationTime"
            label={t('Morning notification time')}
            options={morningHours instanceof Array ? morningHours : morningHours.toArray()}
            normalize={fieldWasChanged('commitNotificationTime')}
          />
          <SelectTimeField
            name="committedNotificationTime"
            label={t('Evening notification time')}
            options={eveningHours instanceof Array ? eveningHours : eveningHours.toArray()}
            normalize={fieldWasChanged('committedNotificationTime')}
          />
          <SelectTimeZonesField timezone={timezone} />
          {isSMSAvailable && (
            <div id="notificationtype">
              <Field
                label={t('Send notifications via')}
                name="notificationType"
                component={RadioButtonNotificationType}
                radioElements={radioElements}
                currentValue={notificationTypeValue}
                onChange={(event, newValue) => {
                  if (isIdentityHasSmsNotificationType && newValue === types.EMAIL && isLoginFlowFinished) {
                    showModal(<ConfirmationNotificationTypeForm />, { important: true, size: 'md' })
                  } else if (isIdentityHasSmsNotificationType && !isLoginFlowFinished && newValue === types.EMAIL) {
                    this.setState({ isShowConfirmationNotificationTypeSection: true })
                  } else {
                    this.setState({ isShowConfirmationNotificationTypeSection: false })
                  }
                }}
              />
            </div>
          )}
        </ContentSection>

        {isShowConfirmationNotificationTypeSection && (
          <ConfirmationNotificationTypeForm
            changeIsShowConfirmationNotificationType={() => this.changeIsShowConfirmationNotificationType(false)}
          />
        )}

        {isShowPhoneInput && isSMSAvailable && (
          <ContentSection title={t('Text Message')} isLastSection={!isDesktopNotificationsAvailable}>
            <InputPhoneNumber
              isRow
              label={t('Your phone number')}
              inputClass={`${bc}__input-phone`}
              labelClass={`${bc}__input-phone-label`}
              className={`${bc}__input-phone-wrapper`}
              isRequired
              form={form}
            />
          </ContentSection>
        )}

        {isDesktopNotificationsAvailable && (
          <ContentSection title={t('Desktop Notifications')} isLastSection>
            <PushSubscribeButton />
          </ContentSection>
        )}

        {error && <ErrorBlock>{error}</ErrorBlock>}
        {!!children &&
          cloneElement(children, {
            submitting,
            pristine,
            invalid,
            isShowFooter: isShowConfirmationNotificationTypeSection,
          })}
      </form>
    )
  }
}

export default TimePreferencesForm
